import React from "react";
import HeaderLogin from "./common/HeaderLogin";
import LanguageContainer from "./common/LanguageContainer";
import LayoutContainer from "./common/LayoutContainer";
import LegalFooter from "./common/LegalFooter";
import PageLocationTag from "./common/PageLocationTag";
import { useRouter } from "./common/Router";
import LoginForm from "./login/LoginForm";
import ForgotPassword from "./password/ForgotPassword";
import ResetPassword from "./password/ResetPassword";
import RegisterForm from "./register/RegisterForm";
import RegistrationBenefits from "./register/RegistrationBenefits";
import HistoryBackProcessor from "./universal-login/HistoryBackProcessor";

const LoginContainerCustomer: React.FC = () => {
  const { loc, setLoc } = useRouter();
  const pathname = window.location.pathname;

  if (pathname === "/lo/reset") {
    return (
      <LanguageContainer>
        <PageLocationTag pageLocationTag="lo-reset" />
        <HeaderLogin />
        <LayoutContainer>
          <ResetPassword />
          <LegalFooter />
        </LayoutContainer>
      </LanguageContainer>
    );
  }

  const prompt = window.AUTH0CONFIG?.extraParams?.prompt;
  if (prompt && prompt === "signup") {
    setLoc("signup");
    window.location.hash = `#signup`;
    window.AUTH0CONFIG.extraParams.prompt = "";
  }
  return (
    <LanguageContainer>
      <PageLocationTag pageLocationTag={loc} />
      <HistoryBackProcessor />
      <HeaderLogin />
      <LayoutContainer>
        {((): JSX.Element => {
          switch (loc) {
            case "login":
              return <LoginForm />;
            case "signup":
              return <RegisterForm />;
            case "reset-password":
              return <ForgotPassword />;
          }
        })()}

        {loc === "login" && <RegistrationBenefits />}

        <LegalFooter />
      </LayoutContainer>
    </LanguageContainer>
  );
};
export default LoginContainerCustomer;
